module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('div', {
    staticClass: "panel panel--header"
  }, [_c('div', {
    staticClass: "layout"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "layout__item desktop--half"
  }, [_c('div', {
    staticClass: "panel__actions text--right"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search__icon",
    on: {
      "click": function($event) {
        _vm.openSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon__search.svg"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "searchInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search__close",
    on: {
      "click": function($event) {
        _vm.closeSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon__close--dark.svg"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "row row--top"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("All Service Providers")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scrollable__wrapper"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('transition-group', {
    staticClass: "list-bare list-hover card-list card-list--11cards",
    attrs: {
      "name": "staggered-fade",
      "tag": "ul",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.search), function(serviceProvider, index) {
    return _c('li', {
      key: index,
      staticClass: "card-list__item",
      attrs: {
        "data-index": index
      }
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item service-provider__name",
      staticStyle: {
        "width": "35%"
      }
    }, [_c('user-icon', {
      attrs: {
        "fullname": serviceProvider.name
      }
    }), _c('h3', {
      staticClass: "font-size--small"
    }, [_vm._v(_vm._s(serviceProvider.name))])], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "35%"
      }
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + serviceProvider.adminContactEmail
      }
    }, [_vm._v(_vm._s(serviceProvider.adminContactEmail))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + serviceProvider.adminContactTelephone
      }
    }, [_vm._v(_vm._s(serviceProvider.adminContactTelephone))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item text--right",
      staticStyle: {
        "width": "10%"
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/service-providers/' + serviceProvider.id
      }
    }, [_vm._v("View Detail")])], 1)])])])
  }))], 1)])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout__item desktop--half"
  }, [_c('h1', [_vm._v("Service Providers")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e7e1489","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ServiceProviders/ServiceProviders.vue
// module id = 533
// module chunks = 1